import React from "react";
import "./InfoCards.css";
import { Link } from "react-router-dom";

function InfoCards() {
  return (
    <div className="cyf_cards_section">
      <div className="container">
        <div className="cyf_cards_wrapper">
          <div className="row">
            <div className="col-md-9">
              <div className="row">
                <div className="col-md-6  col-sm-6 col-6 mb-3">
                  <div className="cyf_card">
                    <div className="img_holder">
                      <img
                        src="/assets/images/check_your_fit/infoCards/img_1.png"
                        className="card_icon_img"
                      />
                    </div>
                    <h4>Do You Have the Drive to Be Your Own Boss?</h4>
                    <p>
                      As a{" "}
                      <b>
                        Profcyma Partner, you control your time, your earnings,
                        and your success.
                      </b>
                    </p>
                    <p>
                      Choose the students you want to mentor, work at your own
                      pace, and build a fulfilling career while helping others
                      achieve theirs.
                    </p>
                  </div>
                </div>

                <div className="col-md-6  col-sm-6 col-6 mb-3">
                  <div className="cyf_card">
                    <div className="img_holder">
                      <img
                        src="/assets/images/check_your_fit/infoCards/img_2.png"
                        className="card_icon_img"
                      />
                    </div>
                    <h4>🌍 Make a Real Impact</h4>
                    <p>Become a catalyst for change.</p>
                    <p>
                      As a Profcyma Partner, you use your knowledge to{" "}
                      <b>coach, counsel, and guide students,</b> helping them
                      make informed academic and career decisions grounded in
                      real analysis — not guesswork.
                    </p>
                  </div>
                </div>

                <div className="col-md-6  col-sm-6 col-6 mb-3">
                  <div className="cyf_card">
                    <div className="img_holder">
                      <img
                        src="/assets/images/check_your_fit/infoCards/img_4.png"
                        className="card_icon_img"
                      />
                    </div>
                    <h4>📚 Growth That Never Stops</h4>
                    <p>The best leaders never stop learning.</p>
                    <p>
                      Profcyma Partners thrive because they embrace{" "}
                      <b>
                        continuous improvement — upgrading, upskilling, and
                        evolving{" "}
                      </b>
                      to stay ahead in the fast-changing education ecosystem.
                    </p>
                  </div>
                </div>

                <div className="col-md-6  col-sm-6 col-6 mb-3">
                  <div className="cyf_card">
                    <div className="img_holder">
                      <img
                        src="/assets/images/check_your_fit/infoCards/img_5.png"
                        className="card_icon_img"
                      />
                    </div>
                    <h4>🚀 Seize a Once-in-a-Generation Opportunity</h4>
                    <p>
                      The Online Education market is exploding — offering
                      massive space for growth.
                    </p>
                    <p>
                      With India’s <b>rising Gross Enrollment Ratio (GER)</b>{" "}
                      and increasing acceptance of digital learning, Profcyma
                      Partners can quickly build a powerful and profitable
                      niche.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="cyf_card  ">
                <div className="img_holder">
                  <img
                    src="/assets/images/check_your_fit/infoCards/img_3.png"
                    className="card_icon_img"
                  />
                </div>
                <h4>💰 Smart Income Potential</h4>
                <p>
             Your earning potential is unlimited.

                </p>
                <p>By supporting new students — and even returning ones in future semesters — <b>a Profcyma Partner can compound their income exponentially,</b> month after month and year after year.</p>
                <Link to="/check-your-form">
                  <button className="cyf_btn">Commission Calculator</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoCards;
